//Dependecies
import React, { useState } from 'react';

//Components
import ButtonFull from '../buttons/ButtonFull';

const CourseTile = (props) => {
  const [statusMessage, setStatusMessage] = useState("");

  const handleEnroll = async (e) => {
    setStatusMessage("");
    
    const requestBody = {
      courseID: props.courseID,
      email: ""
    };

    try {
      const response = await fetch("https://wad-backend.ws381566.remote.ac/enrollUser.php?adminRequired=false", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
        mode: "cors",
      });

      const result = await response.json();
      setStatusMessage(result.message);
      props.toggleModal(props.targetModal)

      if (result.status === "success") {
        const sleep = ms => new Promise(r => setTimeout(r, ms));
        await sleep(3000)
        window.location.href = '/dashboard/courses';
      }
    } catch (error) {
      setStatusMessage(error.message);
    } finally {}
  };

  return (
    <div className='flex flex-col lg:flex-row items-center justify-between gap-10 w-full py-12 px-4 sm:px-6 md:px-10 lg:px-15 rounded-sm bg-white shadow-sm border border-[#DCDCDC] border-b-[#06BD60] border-b-2' id='course'>
      <div className='flex flex-col items-start gap-6 w-full lg:w-1/3' id='courseHeaderContainer'>
        <div className={`${new Date(props.courseDate) < new Date() ? 'flex' : 'hidden'} items-center justify-center bg-blue-600 text-white font-semibold rounded-md py-1 px-3`}>
          <span>Historic</span>
        </div>
        <img 
          className='w-full h-auto object-cover shadow-sm' 
          src={props.courseImage} 
          alt="Course Image" 
        />
        <div className='flex flex-col items-start gap-1' id='courseHeaderTextContainer'>
          <h4 className='text-lg font-medium'>{props.courseTitle}</h4>
          <p>{props.courseDescription}</p>
        </div>
      </div>
      <div className='flex flex-col lg:flex-row items-start lg:items-center lg:justify-end gap-10 lg:gap-20 w-full lg:w-2/3'>
        <div className='flex flex-col gap-6' id='courseStatsContainer'>
          <div className='flex items-center gap-3' id='courseStat'>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#06BD60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user mr-2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
            </svg>
            <h4 className='text-base font-semibold'>{props.enrolled}/{props.maximumEnrolled} Enrolled</h4>
          </div>
          <div className='flex items-center gap-3' id='courseStat'>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#06BD60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-calendar">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            <h4 className='text-base font-medium'>{props.courseDate}</h4>
          </div>
          <div className='flex items-center gap-3' id='courseStat'>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#06BD60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-clock">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            <h4 className='text-base font-medium'>{props.courseTime}</h4>
          </div>
          <div className='flex items-center gap-3' id='courseStat'>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#06BD60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-map-pin">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            <h4 className='text-base font-medium'>{props.courseLocation}</h4>
          </div>
        </div>
        <div className='flex flex-col items-center w-full lg:w-auto' id='courseActionContainer'>
          <div className={`${props.isAdmin ? 'hidden' : 'flex'} flex-col gap-3 w-full`}>
            <button className={`bg-[#06BD60] text-white px-6 py-2 rounded-sm text-center text-base font-medium cursor-pointer w-full ${props.overrideButtonStyles}`} onClick={handleEnroll}>Enroll</button>
            <ButtonFull buttonText='Help' overrideStyles='bg-[#00CCFF]! w-full' navigationURL='/dashboard/help' />
          </div>
          <div className={`${props.isAdmin ? 'flex' : 'hidden'} flex-col gap-3 w-full`}>
            <button className='bg-[#06BD60] text-white px-6 py-2 rounded-sm text-center text-base font-medium cursor-pointer w-full' onClick={() => {props.toggleModal('adminViewCourseParticipantsModal', props.courseID); props.handleDynamicFetchCourseParticipants(props.courseID); props.setStatusMessage("")}}>View Participants</button>
            <button className={`bg-[#00CCFF] text-white px-6 py-2 rounded-sm text-center text-base font-medium cursor-pointer w-full ${props.overrideButtonStyles} ${new Date(props.courseDate) < new Date() ? 'opacity-50 pointer-events-none' : ''}`} onClick={() => props.toggleModal('adminAddNewCourseParticipantModal', props.courseID)}>Enroll Participant</button>
            <button className={`bg-black text-white px-6 py-2 rounded-sm text-center text-base font-medium cursor-pointer w-full ${new Date(props.courseDate) < new Date() ? 'opacity-50 pointer-events-none' : ''}`} onClick={() => {props.toggleModal('adminEditCourseDetailsModal', props.courseID); props.handleDynamicFetchCourseDetails(props.courseID); props.setStatusMessage("")}}>Edit Course Details</button>
            <button className={`bg-red-500 text-white px-6 py-2 rounded-sm text-center text-base font-medium cursor-pointer w-full ${new Date(props.courseDate) < new Date() ? 'opacity-50 pointer-events-none' : ''}`} onClick={() => {props.toggleModal('adminDeleteCourseModal', props.courseID); props.setStatusMessage("")}}>Cancel Course</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseTile;